"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _underscore = require("underscore");

var _ContactPropertyCreatePropertyModal = _interopRequireDefault(require("lead-flows-ui/components/editor/contactProperties/ContactPropertyCreatePropertyModal"));

var _ContactProperties = require("lead-flows-ui/selectors/ContactProperties");

var _ContactProperties2 = require("lead-flows-ui/actions/ContactProperties");

var _ContactProperties3 = require("lead-flows-ui/constants/ContactProperties");

var RequestState = _interopRequireWildcard(require("lead-flows-ui/utils/RequestState"));

var ContactPropertiesCreateProperty =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(ContactPropertiesCreateProperty, _React$PureComponent);
  (0, _createClass2.default)(ContactPropertiesCreateProperty, null, [{
    key: "propTypes",
    get: function get() {
      return {
        contactPropertyGroupsByName: _react.default.PropTypes.array.isRequired,
        createContactProperty: _react.default.PropTypes.func.isRequired,
        createContactPropertyRequestState: _react.default.PropTypes.instanceOf(RequestState.RequestState).isRequired,
        createContactPropertyErrorMessage: _react.default.PropTypes.string.isRequired,
        handleModalClose: _react.default.PropTypes.func.isRequired,
        handleAddField: _react.default.PropTypes.func.isRequired,
        isModalOpened: _react.default.PropTypes.bool.isRequired
      };
    }
  }]);

  function ContactPropertiesCreateProperty() {
    var _this;

    (0, _classCallCheck2.default)(this, ContactPropertiesCreateProperty);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContactPropertiesCreateProperty).call(this));
    _this.handleModalConfirm = _this.handleModalConfirm.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      contactProperty: null,
      saveActionHappened: false
    };
    return _this;
  }

  (0, _createClass2.default)(ContactPropertiesCreateProperty, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      if (this.state.saveActionHappened && nextProps.createContactPropertyRequestState.isSuccessful() && nextState.contactProperty) {
        this.setState({
          saveActionHappened: false
        });
        this.props.handleAddField(nextState.contactProperty);
        this.props.handleModalClose();
      }
    }
  }, {
    key: "handleModalConfirm",
    value: function handleModalConfirm(newContactProperty) {
      if (!this.isEmptyOptionPresent(newContactProperty)) {
        this.props.createContactProperty(newContactProperty);
        this.setState({
          saveActionHappened: true,
          contactProperty: newContactProperty
        });
      }
    }
  }, {
    key: "isEmptyOptionPresent",
    value: function isEmptyOptionPresent(newContactProperty) {
      return (0, _underscore.some)(newContactProperty.options, function (option) {
        return option.value === '';
      });
    }
  }, {
    key: "getCreateContactPropertyErrorSubject",
    value: function getCreateContactPropertyErrorSubject() {
      var foundSubjects = this.props.createContactPropertyErrorMessage.match(/'(.*?)'/);
      return foundSubjects ? foundSubjects[1] : '';
    }
  }, {
    key: "getCreateContactPropertyErrorType",
    value: function getCreateContactPropertyErrorType() {
      var _this2 = this;

      var errorFound = _ContactProperties3.ErrorTypes.NOT_FOUND;
      Object.keys(_ContactProperties3.ErrorReceivedToErrorType).forEach(function (errorMessage) {
        if (_this2.props.createContactPropertyErrorMessage.indexOf(errorMessage) > -1) {
          errorFound = _ContactProperties3.ErrorReceivedToErrorType[errorMessage];
        }
      });
      return errorFound;
    }
  }, {
    key: "maybeRenderModal",
    value: function maybeRenderModal(isModalOpened) {
      var _this$props = this.props,
          handleModalClose = _this$props.handleModalClose,
          contactPropertyGroupsByName = _this$props.contactPropertyGroupsByName,
          createContactPropertyErrorMessage = _this$props.createContactPropertyErrorMessage,
          createContactPropertyRequestState = _this$props.createContactPropertyRequestState;

      if (!isModalOpened) {
        return null;
      }

      return _react.default.createElement(_ContactPropertyCreatePropertyModal.default, {
        contactPropertyGroupsByName: contactPropertyGroupsByName,
        handleModalConfirm: this.handleModalConfirm,
        handleModalReject: handleModalClose,
        errorMessage: createContactPropertyErrorMessage,
        requestState: createContactPropertyRequestState
      });
    }
  }, {
    key: "render",
    value: function render() {
      var isModalOpened = this.props.isModalOpened;
      var maybeModal = this.maybeRenderModal(isModalOpened);
      return _react.default.createElement("span", null, maybeModal);
    }
  }]);
  return ContactPropertiesCreateProperty;
}(_react.default.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  return {
    contactPropertyGroupsByName: (0, _ContactProperties.getContactPropertyGroupsByGroupName)(state),
    createContactPropertyRequestState: (0, _ContactProperties.getCreationRequestState)(state),
    createContactPropertyErrorMessage: (0, _ContactProperties.getCreateContactPropertyErrorMessage)(state)
  };
};

var actionCreators = {
  createContactProperty: _ContactProperties2.createContactProperty
};

var _default = (0, _reactRedux.connect)(mapStateToProps, actionCreators)(ContactPropertiesCreateProperty);

exports.default = _default;
module.exports = exports.default;